module.exports = __webpack_public_path__ + "img/logo.d5f52d2b.jpg";